module.exports = __webpack_public_path__ + "img/facebook-icon.09846073.svg";